import React from 'react'
import "./Sea.css"

const Sea = () => {
    return (
        <div className="sea">
            <h3 className="trusea">Sea Freight</h3>
            <p className="p-sea">
                We ship to various destinations worldwide, from the East African ports of Mombasa. 
                In addition we also offer services to regional ports like Khartoum via Port Sudan, and Somalia to ports like Berbera and Hergesa.
            </p>
        </div>
    )
}

export default Sea